"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFViewer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _reactPdf = require("react-pdf");
require("react-pdf/dist/Page/AnnotationLayer.css");
require("react-pdf/dist/Page/TextLayer.css");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
_reactPdf.pdfjs.GlobalWorkerOptions.workerSrc = "https://unpkg.com/pdfjs-dist@".concat(_reactPdf.pdfjs.version, "/build/pdf.worker.min.mjs");
var MIN_SCALE = 1;
var SCALE_FACTOR = 1.0416;
var PDFViewer = exports.PDFViewer = function PDFViewer(_ref) {
  var blob = _ref.blob;
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    numPages = _useState2[0],
    setNumPages = _useState2[1];
  var _useState3 = (0, _react.useState)(1),
    _useState4 = _slicedToArray(_useState3, 2),
    pageNumber = _useState4[0],
    setPageNumber = _useState4[1];
  var _useState5 = (0, _react.useState)(MIN_SCALE),
    _useState6 = _slicedToArray(_useState5, 2),
    scale = _useState6[0],
    setScale = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    error = _useState8[0],
    setError = _useState8[1];
  var documentRef = (0, _react.useRef)(null);
  function onDocumentLoadSuccess(_ref2) {
    var numPages = _ref2.numPages;
    setNumPages(numPages);
    setError(null);
    console.log("PDF loaded successfully");
  }
  function onDocumentLoadError(error) {
    setError("Failed to load PDF file. Please check the file path or format.");
    console.error("PDF load error", error);
  }
  var handleScroll = function handleScroll() {
    if (documentRef.current) {
      var currentPage = Math.floor(documentRef.current.scrollTop / (scale * SCALE_FACTOR * 540)) + 1;
      if (currentPage <= numPages) setPageNumber(currentPage);
    }
  };
  var handleChangePage = function handleChangePage(currentPage) {
    if (documentRef.current) {
      documentRef.current.scrollTo({
        top: (currentPage - 1) * (scale * SCALE_FACTOR * 550)
      });
    }
  };
  (0, _react.useEffect)(function () {
    var doc = documentRef.current;
    if (doc) {
      doc.addEventListener("scroll", handleScroll);
    }
    return function () {
      if (doc) {
        doc.removeEventListener("scroll", handleScroll);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber, numPages, scale]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flow-column",
    style: {
      maxHeight: "75vh"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "document-view-pdf-toolbar flex space-between "
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex align-items-center",
    style: {
      columnGap: "10px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    type: "number",
    slotProps: {
      htmlInput: {
        min: 1,
        max: numPages
      }
    },
    value: pageNumber,
    onChange: function onChange(e) {
      handleChangePage(+e.target.value);
    },
    size: "small",
    className: "document-view-pdf-page-count"
  }), /*#__PURE__*/_react["default"].createElement("span", null, "of"), /*#__PURE__*/_react["default"].createElement("span", null, numPages)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex align-items-center"
  }, /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    select: true,
    value: scale * 100,
    onChange: function onChange(e) {
      setScale(+e.target.value / 100);
    },
    fullWidth: true,
    margin: "normal",
    variant: "outlined",
    size: "small",
    sx: {
      backgroundColor: "white",
      marginTop: "0",
      marginBottom: "0"
    }
  }, [100, 80, 50, 30, 20].map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
      key: option,
      value: option
    }, "".concat(option, "%"));
  })))), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: "document-view-pdf-file",
    ref: documentRef
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    "data-testid": "pdf-box",
    sx: {
      width: "100%"
    }
  }, error && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      color: "red",
      padding: "1em"
    }
  }, error), !error && blob && /*#__PURE__*/_react["default"].createElement(_reactPdf.Document, {
    file: blob,
    onLoadSuccess: onDocumentLoadSuccess,
    onLoadError: onDocumentLoadError
  }, Array.from(new Array(numPages), function (_, index) {
    return /*#__PURE__*/_react["default"].createElement(_reactPdf.Page, {
      key: "page_".concat(index + 1),
      pageNumber: index + 1,
      scale: scale,
      height: 1000,
      width: 1000
    });
  })))));
};